<template>
  <!-- Header -->
  <div class="relative md:pt-24 pb-32 pt-12" style="background: rgb(5,150,105);
  background: linear-gradient(90deg, rgba(5,150,105,1) 35%, rgba(19,84,122,1) 100%);">
    <div class="px-4 md:px-10 mx-auto w-full">
      <div>
        <!-- Card stats -->
        <div class="flex flex-wrap">
        
          <!-- <div class="w-full lg:w-6/12 xl:w-3/12 px-4 ">
            <router-link to="/general">
            <card-stats
              statSubtitle="นักศึกษาทั้งหมด"
              statTitle="1,897"
              statIconName="fa fa-address-card"
              statIconColor="bg-red-500"
            /> 
            </router-link>
          </div>
        
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <router-link to="/general/subject">
            <card-stats
              statSubtitle="รายวิชาที่เปิดสอน"
              statTitle="256"
              statPercentColor="text-red-500"
              statIconName="fas fa-chart-pie"
              statIconColor="bg-orange-500"
            />
            </router-link>
          </div>
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <router-link to="/general/lecturer">
            <card-stats
              statSubtitle="อาจารย์ทั้งหมด"
              statTitle="924"
              statPercentColor="text-orange-500"
              statIconName="fas fa-users"
              statIconColor="bg-pink-500"
            /> 
            </router-link>
          </div>         
          <div class="w-full lg:w-6/12 xl:w-3/12 px-4">
            <router-link to="/general/resource">
            <card-stats
              statSubtitle="ทรัพยากรในการสอน"
              statTitle="100"
              statPercentColor="text-emerald-500"
              statIconName="fa fa-globe"
              statIconColor="bg-emerald-500"
            />
            </router-link>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import CardStats from "@/components/Cards/CardStats.vue";

export default {
  components: {
    // CardStats,
  },
};
</script>
